import { Box, Grid, Skeleton, Typography, useTheme } from "@mui/material";
import ListHeader from "app/components/BusinessList/ListHeader";
import QRDetails from "app/components/QRList/QRDetails";
import QRListItem from "app/components/QRList/QRListItem";
import { useGetQRListByUserIdQuery } from "lib/features/qrList/qrListService";
import { QRList } from "lib/features/qrList/types";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const QRListScreen = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { id } = useParams();
  const [selectedQR, setSelectedQR] = useState<QRList | undefined>(undefined);

  const {
    data: qrListData,
    error: qrListError,
    isLoading: qrListLoading,
  } = useGetQRListByUserIdQuery({
    id: Number(id),
  });

  const headerBtnAction = () => {
    navigate(`/qrlist/create/${id}`);
  };

  const renderLoadingState = () => (
    <Grid container spacing={2}>
      {Array.from({ length: 8 }).map((_, index) => (
        <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
          <Skeleton variant="rectangular" width="100%" height={50} />
        </Grid>
      ))}
    </Grid>
  );

  const renderErrorState = () => (
    <Typography textAlign={"center"} variant="subtitle1">
      Internal Server Error
    </Typography>
  );

  const renderBusinessList = () => (
    <Grid container spacing={2}>
      {qrListData &&
        qrListData?.length > 0 &&
        qrListData.map((qrcode) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={qrcode.id}>
            <QRListItem qrcode={qrcode} setSelectedQR={setSelectedQR} />
          </Grid>
        ))}
    </Grid>
  );

  const renderNoRecordFound = () => (
    <Typography textAlign={"center"} variant="subtitle1">
      No Record Found
    </Typography>
  );

  return (
    <Box margin="1rem" fontFamily={theme.typography.fontFamily}>
      {/* Header */}
      <ListHeader
        isBackOnly={!!selectedQR}
        onBackPress={() => setSelectedQR(undefined)}
        headerBtnAction={headerBtnAction}
        headerTitle="Stationary QR Codes"
        headerHeadline="Link a business list to a QR code, print it, and update it anytime! Perfect for Airbnbs looking to tailor recommendations for different guests."
        btnTitle="Add New QR Code"
      />

      <Box marginY={2}>
        {qrListLoading ? (
          renderLoadingState()
        ) : qrListError ? (
          renderErrorState()
        ) : selectedQR ? (
          <QRDetails userId={Number(id)} qrcode={selectedQR} />
        ) : qrListData && qrListData.length > 0 ? (
          renderBusinessList()
        ) : (
          renderNoRecordFound()
        )}
      </Box>
    </Box>
  );
};

export default QRListScreen;
